import "./Footer.css";
import logo from "../assets/images/Lyra Infotech Logo white.png";
import { ReactComponent as Email } from "../assets/images/mail1.svg";
import { ReactComponent as Location } from "../assets/images/location1.svg";
import { ReactComponent as Phone } from "../assets/images/phone-call1.svg";
import { ReactComponent as Linkedin } from "../assets/images/LinkedIn-icon.svg";
import { Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faPhone,
  faEnvelope,
} from "@fortawesome/free-solid-svg-icons";

import { faLinkedin } from "@fortawesome/free-brands-svg-icons";

function Footer() {
  return (
    <>
      <div className="footer ">
        <div className="container">
          <Row>
            <div className="d-flex container justify-content-around flex-wrap text-center text-sm-start gap-3 gap-md-3 gap-sm-0 ">
              <Col lg={3} md={12} sm={12}>
                <div className="footer-logo">
                  <Link to="/">
                    <img src={logo} alt="" style={{ height: "70px" }} />
                  </Link>
                  <p className="mt-4 p" style={{ fontSize: "16px" }}>
                    Lyra Infotech is a product-based technology company building
                    innovative mobile and web applications for global users.
                  </p>
                </div>
              </Col>
              <div>
                <h4 className="heading">Important Link</h4>
                <ul className="mt">
                  <div className="d-flex flex-column gap">
                    <li>
                      <Link to="/" className="nav-link">
                        Home
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" className="nav-link">
                        About Us
                      </Link>
                    </li>
                    <li>
                      <Link to="/services" className="nav-link">
                        Products
                      </Link>
                    </li>
                    <li>
                      <Link to="/careers" className="nav-link">
                        Careers
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact" className="nav-link">
                        Contact Us
                      </Link>
                    </li>
                  </div>
                </ul>
              </div>
              <div>
                <h4 className="heading">Products</h4>
                <ul className="mt">
                  <div className="d-flex flex-column gap">
                    <li>
                      <Link to="/services" className="nav-link">
                        Scalable Web Platforms{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="/services" className="nav-link">
                        Global Mobile Applications{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="/services" className="nav-link">
                        Tools & Utility Ecosystems{" "}
                      </Link>
                    </li>
                    <li>
                      <Link to="/services" className="nav-link">
                        Content & Gaming Platforms{" "}
                      </Link>
                    </li>
                  </div>
                </ul>
              </div>
              <div>
                <h4 className="heading">Contact</h4>

                <div className="footer-contact-list mt">
                  <div className="footer-contact-item">
                    <FontAwesomeIcon
                      icon={faLocationDot}
                      className="footer-icon"
                    />
                    <p className="footer-contact-text mb-0">
                      135, Tulsi Arcade, Near Sudama Chowk,
                      <br />
                      Mota Varachha, Surat, Gujarat - 394101
                    </p>
                  </div>

                  <div className="footer-contact-item">
                    <FontAwesomeIcon icon={faPhone} className="footer-icon" />
                    <p className="footer-contact-text mb-0">+91 9825571557</p>
                  </div>

                  <div className="footer-contact-item">
                    <FontAwesomeIcon
                      icon={faEnvelope}
                      className="footer-icon"
                    />
                    <p className="footer-contact-text mb-0">
                      info@lyrainfotech.com
                    </p>
                  </div>

                  <div className="footer-contact-item">
                    <FontAwesomeIcon
                      icon={faLinkedin}
                      className="footer-icon linkedin"
                    />
                    <a
                      href="https://www.linkedin.com/company/lyrainfotech/"
                      target="_blank"
                      rel="noreferrer"
                      className="footer-contact-text"
                    >
                      LinkedIn
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Row>
          <hr className="container mt-5" />
          <div>
            <p className="text-center p-2 p mb-0">
              Copyright © 2026 Lyra Infotech. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Footer;
